import {observable, action, computed, createTransformer, reaction, extendObservable} from "mobx";
import TimesheetService from "../../../../services/TimesheetService";
import moment from "moment";
import _ from 'lodash';
import {getNomeFluxosById} from "../../../../utils/enums";
import TarefaService from "../../../../services/TarefaService";
import PagamentosService from "../../../../services/PagamentosService";
import {formatarDataISO8601} from "../../../../utils/formatar";


export default class PagamentoStore {

    @observable pagamento;
    @observable dataEmissaoValidacao;
    @observable dataVencimentoValidacao;
    @observable idSolicitacaoExibicao;
    @observable possiveisAcoes;
    @observable detalhesPagamento;
    @observable loadingDetalhesPagamento;

    constructor(validacaoStore, loadingPanelStore) {
        this.resetPagamento();
        this.loadingPanelStore                      = loadingPanelStore;
        this.validacaoStore                         = validacaoStore;
        this.dataVencimentoValidacao                = null;
        this.dataEmissaoValidacao                   = null;
        this.possiveisAcoes                         = [];
        this.idSolicitacaoExibicao                  = null;
        this.detalhesPagamento                      = {};
        this.solicitacao                            = {};

        this.pagamentoService                       = new PagamentosService();
    }

    carregarDados(id) {
        this.idSolicitacaoExibicao = id;
        this.pagamento.lotePagamentoId = id;
        this.possiveisAcoes = ["ENVIAR_PAGAMENTO"];

        this.loadingPanelStore.setIsLoading("DetalhesPagamentoLoading", true);
        this.pagamentoService.detalhesLote(id).then(response => {
            this.loadingPanelStore.setIsLoading("DetalhesPagamentoLoading", false);
            this.detalhesPagamento = response.data;
            this.pagamento.valor = this.detalhesPagamento.valorTotal;
        }).catch(error => {
            this.loadingPanelStore.setIsLoading("DetalhesPagamentoLoading", false);
            console.log(error)
        });
    }

    resetPagamento() {
        this.pagamento = {
            numero:             null,
            dataEmissao:        null,
            dataVencimento:     null,
            serie:              null,
            lotePagamentoId:    null,
            valor:              null
        }
    }

    checkDataEmissao = (value) =>{
        this.dataEmissaoValidacao = value;
        if(!this.validacaoStore.isDate(value)) {
            this.pagamento.dataEmissao = null;
        }
    };

    checkDataVencimento = (value) =>{
        this.dataVencimentoValidacao = value;
        if(!this.validacaoStore.isDate(value)) {
            this.pagamento.dataVencimento = null;
        }
    };

    setDataEmissao = (value) => {
        this.pagamento.dataEmissao = value;
        if(value) {
            this.dataEmissaoValidacao = value.format("DD/MM/YYYY")
        } else {
            this.dataEmissaoValidacao = null;
        }
    };

    setDataVencimento = (value) => {
        this.pagamento.dataVencimento = value;
        if(value) {
            this.dataVencimentoValidacao = value.format("DD/MM/YYYY")
        } else {
            this.dataVencimentoValidacao = null;
        }
    };

    setNumero = (value) => {
        this.pagamento.numero = value;
    };

    setSerie = (value) => {
        this.pagamento.serie = value;
    };

    setObservacoes = (value) => {};

    enviarPagamento = (id) => {
        const notaFiscal = Object.assign({}, this.pagamento);
        notaFiscal.dataEmissao = moment(notaFiscal.dataEmissao).toJSON();
        notaFiscal.dataVencimento = moment(notaFiscal.dataVencimento).toJSON();
        return this.pagamentoService.enviarNotaFiscal(notaFiscal)
    };
}